<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.unitId" :getMethod="getUnit"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";

export default {
  name: "ViewUnitContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Unit
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.unitId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.UnitChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>